import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getCategoryServices = (categoryId: string) => {
  return axiosPrivate.get(`/bills/api/v1/categories/${categoryId}/services/`);
};
